import React, { useMemo, useRef, useState } from "react";

import { Box } from "@chakra-ui/react";
import {
  GoalSavingsStatusEnum,
  IGoalSavings,
} from "api/individual-savings/types";
import { ReactComponent as MenuDotsIcon } from "assets/icons/menu-dots.svg";
// import { TWO_DIGITS } from "features/individuals/individual-details/consts";
import {
  IMoreQuickActionItem, // IMoreQuickActionsProps,
  TQuickActionType,
} from "features/individuals/individual-details/more-quick-actions/types";
import {
  individualDetailsQuickActionBtnCss3,
  moreQuickActionsDropDownPopUpMenuContentCss4,
} from "features/individuals/individual-details/styles";
import { useNavigate } from "react-router-dom";
import { ROUTES } from "routes/constants";

import { DropDown } from "ui/dropdown";
import { IDropDownRef } from "ui/dropdown/types";
// import { TTableRowData } from "ui/table/types";
import { Paragraph3 } from "ui/typography";

import { CloseSavingsModal } from "../../CloseSavingsModal";
import { PauseSavingsModal } from "./PauseSavingsModal";
import { ResumeSavingsModal } from "./ResumeSavingsModal";

const textColorMap: Record<TQuickActionType, string> = {
  regular: "#1A202C",
  disabled: "#344054",
  danger: "#DC2626",
};
const DROP_DOWN_WIDTH = 240;

export const GOAL_SAVINGS_ENABLED_PAUSED_STATUS: GoalSavingsStatusEnum[] = [
  GoalSavingsStatusEnum.ACTIVE,
  GoalSavingsStatusEnum.PAUSED,
];

interface INewMoreQuickActionsProps {
  individualsSavingDetails: IGoalSavings;
}

export const MoreQuickActions = (props: INewMoreQuickActionsProps) => {
  const { individualsSavingDetails } = props;

  const navigate = useNavigate();

  const [isResumeSavingsModalOpen, setIsResumeSavingsModalOpen] =
    useState(false);
  const [isPauseSavingsModalOpen, setIsPauseSavingsModalOpen] = useState(false);
  const [isCloseSavingsModalOpen, setIsCloseSavingsModalOpen] = useState(false);
  const dropDownRef = useRef<IDropDownRef | null>(null);

  const handleToggleResumeSavingsModal = () =>
    setIsResumeSavingsModalOpen(!isResumeSavingsModalOpen);
  const handleTogglePauseSavingsModal = () =>
    setIsPauseSavingsModalOpen(!isPauseSavingsModalOpen);
  const handleToggleCloseSavingsModal = () =>
    setIsCloseSavingsModalOpen(!isCloseSavingsModalOpen);

  const handleToggleDropDown = () => {
    if (!dropDownRef.current) return;
    dropDownRef.current.handleToggleDropdown();
  };
  const quickActions: IMoreQuickActionItem[] = useMemo(() => {
    if (!individualsSavingDetails) return [];
    const { status } = individualsSavingDetails;
    const isPauseResumeDisabled =
      !GOAL_SAVINGS_ENABLED_PAUSED_STATUS.includes(status);

    return [
      {
        label: "View Plan Details",
        isDisabled: false,
        handleQuickActionItemClick: () => {
          handleToggleDropDown();
          navigate(
            `${ROUTES.INDIVIDUALS_GOAL_SAVINGS_PAGE}/${individualsSavingDetails?.id}/view-savings-details`
          );
        },
        type: "regular",
      },
      {
        label: "View Saving’s History",
        isDisabled: false,
        handleQuickActionItemClick: () => {
          handleToggleDropDown();
          navigate(
            `${ROUTES.INDIVIDUALS_GOAL_SAVINGS_PAGE}/${individualsSavingDetails?.id}/view-savings-history`
          );
        },
        type: "regular",
      },
      {
        label: status !== "active" ? "Resume Savings" : "Pause Savings",
        isDisabled: isPauseResumeDisabled,
        handleQuickActionItemClick: () => {
          if (isPauseResumeDisabled) return;
          handleToggleDropDown();
          if (status !== "active") {
            handleToggleResumeSavingsModal();
          } else {
            handleTogglePauseSavingsModal();
          }
        },
        type: isPauseResumeDisabled ? "disabled" : "regular",
      },
      {
        label: "Close Savings",
        isDisabled: status === "stopped" ? true : false,
        handleQuickActionItemClick: () => {
          if (status === "stopped") return;
          handleToggleDropDown();
          handleToggleCloseSavingsModal();
        },
        type: "danger",
      },
    ];
  }, [individualsSavingDetails]);

  return (
    <>
      <DropDown
        dropDownWidth={DROP_DOWN_WIDTH}
        dropDownBtnContent={
          <>
            <MenuDotsIcon className="w-4 h-4" />
          </>
        }
        allowOutSideClick
        customDropDownButtonCss={individualDetailsQuickActionBtnCss3}
        dropDownPopUpMenuContentCss={
          moreQuickActionsDropDownPopUpMenuContentCss4
        }
        ref={dropDownRef}
      >
        <Box className="flex flex-col">
          {quickActions.map(
            ({ label, isDisabled, handleQuickActionItemClick, type }, idx) => {
              // if (
              //   individualsSavingDetails?.type === "goal" &&
              //   idx === TWO_DIGITS
              // ) {
              //   return null; // Skip rendering this item
              // }
              return (
                <Box
                  className={`h-10 py-[10px] flex items-center ${isDisabled ? "cursor-not-allowed" : "cursor-pointer"}`}
                  key={idx}
                  onClick={handleQuickActionItemClick}
                >
                  <Paragraph3
                    textColor={textColorMap[type]}
                    lineHeight="20px"
                    fontWeight="600"
                  >
                    {label}
                  </Paragraph3>
                </Box>
              );
            }
          )}
        </Box>
      </DropDown>
      <>
        <PauseSavingsModal
          isOpen={isPauseSavingsModalOpen}
          setIsOpen={setIsPauseSavingsModalOpen}
          handleTogglePauseSavingsModal={handleTogglePauseSavingsModal}
          id={individualsSavingDetails.id}
          type="goal"
        />
        <ResumeSavingsModal
          isOpen={isResumeSavingsModalOpen}
          setIsOpen={setIsResumeSavingsModalOpen}
          handleToggleResumeSavingsModal={handleToggleResumeSavingsModal}
          id={individualsSavingDetails.id}
          type="goal"
        />
      </>
      <CloseSavingsModal
        isOpen={isCloseSavingsModalOpen}
        setIsOpen={setIsCloseSavingsModalOpen}
        handleToggleCloseSavingsModal={handleToggleCloseSavingsModal}
        id={individualsSavingDetails.id}
        type="goal"
      />
    </>
  );
};
